/* Desi Roots — brand behaviours
   Vanilla, no libraries. Everything degrades to visible-and-static if JS
   fails or the visitor prefers reduced motion. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     1. Scroll reveal — one shared observer, fires once at 20%.
     --------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.dr-reveal');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('dr-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('dr-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }
    );

    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------
     2. Mobile bar — hide on scroll down, show on scroll up.
     --------------------------------------------------------------- */
  function initMobileBar() {
    var bar = document.querySelector('.dr-mobile-bar');
    if (!bar) return;

    document.body.classList.add('dr-has-mobile-bar');

    var last = window.pageYOffset;
    var ticking = false;

    function update() {
      var now = window.pageYOffset;
      if (now > last && now > 220) {
        bar.setAttribute('data-hidden', 'true');
      } else {
        bar.setAttribute('data-hidden', 'false');
      }
      last = now < 0 ? 0 : now;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  /* ---------------------------------------------------------------
     3. Cart badge — bump when the theme publishes a cart update.
     --------------------------------------------------------------- */
  function initCartBadge() {
    var badge = document.querySelector('.dr-mobile-bar__badge');
    if (!badge) return;

    function bump() {
      badge.setAttribute('data-bump', 'true');
      setTimeout(function () { badge.removeAttribute('data-bump'); }, 320);
    }

    // Sense/Dawn publish cart updates through their pubsub helper.
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            badge.textContent = cart.item_count;
            badge.hidden = cart.item_count === 0;
            if (!reduced) bump();
          })
          .catch(function () { /* leave the badge as rendered */ });
      });
    }
  }

  /* ---------------------------------------------------------------
     4. Sticky add-to-cart — appears once the real button leaves view.
     --------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('.dr-sticky-atc');
    if (!bar) return;

    var target = document.querySelector('.dr-sticky-atc__watch') ||
                 document.querySelector('product-form .product-form__submit');
    if (!target) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      io.observe(target);
    }

    var proxy = bar.querySelector('[data-dr-atc-proxy]');
    var priceEl = bar.querySelector('.dr-sticky-atc__price');

    // Proxy the click through to the real form button so variant state,
    // validation and the cart drawer all keep working.
    if (proxy) {
      proxy.addEventListener('click', function (event) {
        event.preventDefault();
        var real = document.querySelector('product-form .product-form__submit');
        if (real) real.click();
      });
    }

    /* product-info.js only swaps #price-{section}, Sku, Inventory, Volume and
       Price-Per-Item when a variant changes — the sticky bar is not in that
       list, so it has to sync itself or it goes stale. The price is copied
       from the live price element rather than reformatted here, so currency,
       sale prices and "from" pricing all stay correct. */
    function syncFromDom(sectionId) {
      var source = document.getElementById('price-' + sectionId);
      if (source && priceEl) {
        var regular = source.querySelector('.price-item--sale, .price-item--regular') || source;
        var text = regular.textContent.replace(/\s+/g, ' ').trim();
        if (text) priceEl.textContent = text;
      }
    }

    function syncButton(variant) {
      if (!proxy) return;
      var available = variant && variant.available;
      proxy.disabled = !available;
      proxy.textContent = available
        ? 'Add to cart'
        : (variant ? 'Sold out' : 'Unavailable');
    }

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var d = (event && event.data) || {};
        syncFromDom(d.sectionId);
        syncButton(d.variant);
      });
    }
  }

  function init() {
    initReveal();
    initMobileBar();
    initCartBadge();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run inside the theme editor so newly added sections behave.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', initReveal);
})();
